import { useStore } from "@/stores/store";

export default defineNuxtRouteMiddleware((_to, from) => {
  const store = useStore();
  // Set Default values from localStorage if exists
  store.site = localStorage.getItem("site") !== "" ? localStorage.getItem("site") : "";
  store.version = localStorage.getItem("version") !== "" ? localStorage.getItem("version") : "";
  store.noIntro = localStorage.getItem("noIntro") !== "" ? localStorage.getItem("noIntro") : "false";
  store.xtor = localStorage.getItem("xtor") !== "" ? localStorage.getItem("xtor") : null;
  store.code_aff = localStorage.getItem("code_aff") !== "" ? localStorage.getItem("code_aff") : null;
  // Set values from qry if exists, to overwrite localStorage values
  if (Object.keys(from.query).length) {
    Object.entries(from.query).forEach((qry) => {
      if (store[qry[0]] !== undefined) {
        localStorage.setItem(qry[0], qry[1]);
        store[qry[0]] = qry[1];
      }
    });
  }
});
